<template>
  <div id="app" v-title :title="$t('title')">
    <share />
  </div>
</template>

<script>
import share from './components/share'

export default {
  name: 'App',
  components: {
    share
  },
  created () {
    this.url = window.location.href
    // 测试
    // if (this.lang === 'en') {
    //   this.$i18n.locale = 'en'
    // }
    // console.log(navigator)
    const lang = (
      navigator.language ||
      navigator.userLanguage ||
      'en'
    ).toLowerCase()
    if (lang.includes('zh')) {
      this.lang = 'zh'
      this.$i18n.locale = 'zh'
    } else if (lang.includes('en')) {
      this.lang = 'en'
      this.$i18n.locale = 'en'
    } else {
      this.lang = 'th'
      this.$i18n.locale = 'th'
    }
  }
}

</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 16px; */
}
* {
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue